import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const SelectOptionsWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "select-options-wrapper",
})`
  display: flex;
  align-items: center;
`;

export const SelectOptionItemStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "select-option-item",
})``;

export const SelectCheckboxWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "select-checkbox-wrapper",
})`
  display: flex;
  align-items: center;
  height: 22px;
`;
